export const IS_LOCAL = window.location.hostname === 'localhost';
